import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { ITransactionMandate } from '../../../types/transactionMandate';
import { RootState } from '../..';

interface IGetTransactionMandatesResponse {
  status?: boolean;
  message?: string;
  data?: ITransactionMandate[];
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetTransactionMandatesResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getTransactionMandatesAsync = createAsyncThunk(
  'transactionMandates',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get('/transaction/mandates', config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const transactionMandatesGetSlice = createSlice({
  name: 'transactionMandates/get',
  initialState,
  reducers: {
    resetGetTransactionMandates: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTransactionMandatesAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getTransactionMandatesAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetTransactionMandatesResponse;
      })
      .addCase(getTransactionMandatesAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetTransactionMandatesResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetTransactionMandates } =
  transactionMandatesGetSlice.actions;

export default transactionMandatesGetSlice.reducer;
